/**
 * API 相关常量
 */
/** 默认分页大小 */
export const DEFAULT_PAGE_SIZE = 20;

/** 机器人列表等大列表分页 */
export const LARGE_PAGE_SIZE = 100;

/** 坐席、会话消息等超大列表分页 */
export const XL_PAGE_SIZE = 100;

/** 小表格分页（如问答模板列表） */
export const SMALL_PAGE_SIZE = 10;

/** 分页组件「每页条数」默认可选项 */
export const PAGE_SIZE_OPTIONS = [10, 20, 50, 100];

/** 同步导出/导入等后端耗时随数据量增长的请求超时（毫秒），默认 10s 在大客户数据量下会提前报错 */
export const LONG_REQUEST_TIMEOUT_MS = 120_000;
